import { getSuperadminV2 } from './superadminV2Locale';

export { getSuperadminV2 };

export function getLoginV2(lang) {
  const L = LOGIN_V2[lang] || LOGIN_V2.en;
  return L;
}

export function getSupportV2(lang) {
  return SUPPORT_V2[lang] || SUPPORT_V2.en;
}

export function getUidMgmtV2(lang) {
  const L = lang === 'uk' ? 'uk' : 'en';
  return {
    ...UID_MGMT_V2[L],
    tags: UID_TAGS_TAB[L],
    stations: UID_STATIONS_TAB[L],
    alarmRules: UID_ALARM_RULES_TAB[L],
    trends: UID_TREND_CONFIGS_TAB[L],
    codeGroups: UID_CODE_GROUPS_TAB[L],
    commandTemplates: UID_COMMAND_TEMPLATES_TAB[L],
    cards: UID_CARDS_TAB[L],
    svg: UID_SVG_TAB[L],
    telegram: UID_TELEGRAM_TAB[L],
  };
}

const LOGIN_V2 = {
  uk: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    title: 'Авторизація V2',
    projectLabel: 'Проєкт (назва)',
    projectHelper: 'Оберіть зі списку або натисніть +, щоб додати',
    username: 'Нікнейм або email',
    password: 'Пароль',
    rememberMe: 'Запамʼятати мене',
    submit: 'Увійти',
    projectNotFound: 'Проєкт не знайдено',
    badCredentials: 'Невірний логін або пароль',
    loginFailed: 'Помилка входу',
    logout: 'Вийти',
    sessionSignedIn: 'Ви увійшли як {{user}} ({{role}}).',
    roleSuperadmin: 'суперадмін',
    roleSupport: 'підтримка',
    roleAdmin: 'адмін',
    roleUser: 'користувач',
    tabLogin: 'Вхід',
    tabRegister: 'Реєстрація',
    registerTitleHint: 'Самореєстрація доступна лише для ролі SuperAdmin.',
    registerEmail: 'Email',
    registerUsernameOptional: "Ім'я користувача (опційно)",
    registerPassword: 'Пароль',
    registerPasswordRepeat: 'Повторіть пароль',
    registerSubmit: 'Зареєструватися',
    registerSubmitting: 'Створення...',
    hideRegistration: 'Сховати реєстрацію',
    showRegistration: 'Самореєстрація SuperAdmin',
    passwordMismatch: 'Паролі не співпадають.',
    registrationCreated:
      'Акаунт створено. Перевірте пошту і підтвердіть email перед входом.',
    registrationFailed: 'Помилка реєстрації',
    emailNotVerifiedBlocked:
      'Email не підтверджено. Вхід заблоковано до підтвердження.',
    resendVerification: 'Надіслати лист повторно',
    resendSent: 'Лист надіслано. Перевірте пошту.',
    resendFailed: 'Не вдалося надіслати лист.',
    verifyRequiredSoft:
      'Підтвердіть email для підвищення безпеки акаунта.',
    verifySuccess: 'Пошту успішно підтверджено{{login}}. Тепер можна увійти.',
    verifyFailed: 'Не вдалося підтвердити пошту{{reason}}',
    bindEmailRequired:
      'Для цього суперадміну потрібно привʼязати email. Доступ не обмежено.',
    bindEmailPlaceholder: 'Вкажіть email для привʼязки',
    bindEmailAction: 'Привʼязати email',
    bindEmailSent:
      'Email привʼязано. Лист з підтвердженням відправлено.',
    bindEmailFailed: 'Не вдалося привʼязати email.',
    bindEmailModalTitle: 'Привʼязка email до акаунта',
    bindEmailSend: 'Надіслати лист',
    commonCancel: 'Скасувати',
  },
  en: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    title: 'Sign in (V2)',
    projectLabel: 'Project (name)',
    projectHelper: 'Pick from the list or press + to add',
    username: 'Nickname or email',
    password: 'Password',
    rememberMe: 'Remember me',
    submit: 'Sign in',
    projectNotFound: 'Project not found',
    badCredentials: 'Invalid username or password',
    loginFailed: 'Sign-in failed',
    logout: 'Log out',
    sessionSignedIn: 'Signed in as {{user}} ({{role}}).',
    roleSuperadmin: 'superadmin',
    roleSupport: 'support',
    roleAdmin: 'admin',
    roleUser: 'user',
    tabLogin: 'Sign in',
    tabRegister: 'Register',
    registerTitleHint: 'Self-signup is available for SuperAdmin only.',
    registerEmail: 'Email',
    registerUsernameOptional: 'Username (optional)',
    registerPassword: 'Password',
    registerPasswordRepeat: 'Repeat password',
    registerSubmit: 'Register',
    registerSubmitting: 'Creating...',
    hideRegistration: 'Hide registration',
    showRegistration: 'SuperAdmin self-signup',
    passwordMismatch: 'Passwords do not match.',
    registrationCreated:
      'Account created. Check your email and confirm it before sign-in.',
    registrationFailed: 'Registration failed',
    emailNotVerifiedBlocked:
      'Email is not verified. Sign-in is blocked until confirmation.',
    resendVerification: 'Resend email',
    resendSent: 'Email sent. Please check your inbox.',
    resendFailed: 'Failed to send email.',
    verifyRequiredSoft:
      'Please verify your email for better account security.',
    verifySuccess: 'Email has been verified{{login}}. You can sign in now.',
    verifyFailed: 'Email verification failed{{reason}}',
    bindEmailRequired:
      'This superadmin account should bind email. Access remains available.',
    bindEmailPlaceholder: 'Enter email to bind',
    bindEmailAction: 'Bind email',
    bindEmailSent: 'Email bound. Verification email has been sent.',
    bindEmailFailed: 'Failed to bind email.',
    bindEmailModalTitle: 'Bind email to account',
    bindEmailSend: 'Send email',
    commonCancel: 'Cancel',
  },
};

const SUPPORT_V2 = {
  uk: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    title: 'Support V2',
    logout: 'Вийти',
    tabUid: 'UID',
    tabSuperadmins: 'Суперадміни',
    tabProjects: 'Проєкти',
    tabAssignments: 'Призначення UID',
    tabLive: 'Ефір',
    liveConnections: 'Зараз на звʼязку',
    liveEmptyConn: 'Відкритих сокетів немає',
    liveLog: 'Стрічка',
    liveEmptyLog: 'Поки тихо',
    liveColTime: 'Час',
    liveColDir: 'Що',
    liveColIp: 'IP',
    liveColWho: 'Хто',
    liveColWhat: 'Розбір',
    liveIn: 'прийшло',
    liveOut: 'пішло',
    liveConnect: 'сокет',
    liveClose: 'обрив',
    liveStation: 'ст.',
    liveDetail: 'Деталі',
    liveRaw: 'Сирий кадр',
    liveDecoded: 'Розібрані теги',
    liveData: 'Секція даних',
    liveGone: 'Цей рядок уже випав зі стрічки',
    liveSent: 'ушло в сокет',
    liveBuffered: 'в буфере',
    liveNoSocket: 'сокета нет',
    liveWriteError: 'ошибка записи',
    createUid: 'Створити UID',
    name: 'Назва',
    uidUuidOptional:
      'UID (UUID, опційно — залиште порожнім для автогенерації)',
    uidHelper:
      'Формат UUID: 36 символів (8-4-4-4-12). У TCP пакетах UUID без дефісів (32 hex). Якщо не вказано — згенерується автоматично.',
    create: 'Створити',
    colId: 'ID',
    colName: 'Назва',
    colUuid: 'UUID',
    colActions: 'Дії',
    colEmail: 'Email',
    createSuperAdmin: 'Створити суперадміна',
    login: 'Логін',
    password: 'Пароль',
    createProject: 'Створити проєкт',
    ownerLabel: 'Власник (суперадмін)',
    slug: 'Slug',
    host: 'Host',
    port: 'Port',
    dbUser: 'DB User',
    dbPassword: 'DB Password',
    createProjectBtn: 'Створити проєкт',
    colLinkedUids: 'Привʼязані UID',
    colOwner: 'Власник',
    noLinkedUids: 'Немає привʼязаних UID',
    assignUidTitle: 'Призначити UID суперадміну',
    superAdmin: 'Суперадмін',
    assign: 'Призначити',
    colSuperAdmin: 'Суперадмін',
    dlgDeleteUidTitle: 'Видалити UID?',
    dlgDeleteSaTitle: 'Видалити суперадміна?',
    dlgDeleteProjectTitle: 'Видалити проєкт?',
    projectLabel: 'Проєкт',
    alsoDropDb: 'Також видалити базу даних',
    dlgEditSaTitle: 'Редагувати суперадміна',
    newPasswordOptional: 'Новий пароль (порожньо = не змінювати)',
    cancel: 'Скасувати',
    delete: 'Видалити',
    save: 'Зберегти',
    close: 'Закрити',
    alertEnterUidName: 'Введіть назву UID',
    alertUidLen: 'UID має бути довжиною 36 символів (формат UUID)',
    alertUidFormat: 'UID має бути у форматі UUID (наприклад: 550e8400-e29b-41d4-a716-446655440000)',
    alertUidExists: 'UID з таким кодом вже існує:',
    alertUidCreated: 'UID створено',
    alertUidCreateErr: 'Помилка створення UID',
    alertUidDeleted: 'UID видалено',
    alertUidDeleteErr: 'Помилка видалення UID',
    alertFillLoginPass: 'Заповніть логін і пароль',
    alertSaCreated: 'Суперадміна створено',
    alertSaCreateErr: 'Помилка створення суперадміна',
    alertNoChanges: 'Змін не виявлено',
    alertSaUpdated: 'Суперадміна оновлено',
    alertSaUpdateErr: 'Помилка оновлення суперадміна',
    alertSaDeleted: 'Суперадміна видалено',
    alertSaDeleteErr: 'Помилка видалення суперадміна',
    alertFillRequired: 'Заповніть усі обовʼязкові поля',
    alertProjectDeleted: 'Проєкт видалено',
    alertProjectCreateErr: 'Помилка створення проєкту',
    alertProjectDeleteErr: 'Помилка видалення проєкту',
    alertPickUidSa: 'Оберіть UID і суперадміна',
    alertAssigned: 'UID призначено суперадміну',
    alertAssignErr: 'Помилка призначення UID',
    alertUnassigned: 'Призначення UID видалено',
    alertUnassignErr: 'Помилка видалення призначення',
    projectCreatedFallback: 'Проєкт створено',
    billingTopUpBtn: 'Баланс',
    billingTopUpTitle: 'Поповнити баланс',
    billingTopUpCurrent: 'Поточний баланс',
    billingTopUpAmount: 'Сума (USD)',
    billingTopUpNote: 'Примітка (опційно)',
    billingTopUpSubmit: 'Поповнити',
    billingTopUpOk: 'Баланс поповнено',
    billingTopUpFailed: 'Помилка поповнення',
    billingTopUpLoadFailed: 'Не вдалося завантажити баланс',
    billingTopUpAmountInvalid: 'Вкажіть додатню суму',
  },
  en: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    title: 'Support V2',
    logout: 'Log out',
    tabUid: 'UID',
    tabSuperadmins: 'Superadmins',
    tabProjects: 'Projects',
    tabAssignments: 'UID assignments',
    tabLive: 'Live',
    liveConnections: 'Connected now',
    liveEmptyConn: 'No open sockets',
    liveLog: 'Tape',
    liveEmptyLog: 'Quiet so far',
    liveColTime: 'Time',
    liveColDir: 'What',
    liveColIp: 'IP',
    liveColWho: 'Who',
    liveColWhat: 'Decoded',
    liveIn: 'in',
    liveOut: 'out',
    liveConnect: 'socket',
    liveClose: 'drop',
    liveStation: 'st.',
    liveDetail: 'Details',
    liveRaw: 'Raw frame',
    liveDecoded: 'Decoded tags',
    liveData: 'Data section',
    liveGone: 'This row already fell off the tape',
    liveSent: 'written to socket',
    liveBuffered: 'still in buffer',
    liveNoSocket: 'no socket',
    liveWriteError: 'write error',
    createUid: 'Create UID',
    name: 'Name',
    uidUuidOptional: 'UID (UUID, optional — leave empty for auto-generation)',
    uidHelper:
      'UUID format: 36 characters (8-4-4-4-12). In TCP packets UUID is 32 hex chars without dashes. If empty, it will be generated.',
    create: 'Create',
    colId: 'ID',
    colName: 'Name',
    colUuid: 'UUID',
    colActions: 'Actions',
    colEmail: 'Email',
    createSuperAdmin: 'Create superadmin',
    login: 'Login',
    password: 'Password',
    createProject: 'Create project',
    ownerLabel: 'Owner (superadmin)',
    slug: 'Slug',
    host: 'Host',
    port: 'Port',
    dbUser: 'DB User',
    dbPassword: 'DB Password',
    createProjectBtn: 'Create project',
    colLinkedUids: 'Linked UIDs',
    colOwner: 'Owner',
    noLinkedUids: 'No linked UIDs',
    assignUidTitle: 'Assign UID to superadmin',
    superAdmin: 'Superadmin',
    assign: 'Assign',
    colSuperAdmin: 'Superadmin',
    dlgDeleteUidTitle: 'Delete UID?',
    dlgDeleteSaTitle: 'Delete superadmin?',
    dlgDeleteProjectTitle: 'Delete project?',
    projectLabel: 'Project',
    alsoDropDb: 'Also drop database',
    dlgEditSaTitle: 'Edit superadmin',
    newPasswordOptional: 'New password (empty = keep unchanged)',
    cancel: 'Cancel',
    delete: 'Delete',
    save: 'Save',
    close: 'Close',
    alertEnterUidName: 'Enter UID name',
    alertUidLen: 'UID must be 36 characters (UUID format)',
    alertUidFormat: 'UID must be a valid UUID (e.g. 550e8400-e29b-41d4-a716-446655440000)',
    alertUidExists: 'A UID with this code already exists:',
    alertUidCreated: 'UID created',
    alertUidCreateErr: 'Failed to create UID',
    alertUidDeleted: 'UID deleted',
    alertUidDeleteErr: 'Failed to delete UID',
    alertFillLoginPass: 'Enter login and password',
    alertSaCreated: 'Superadmin created',
    alertSaCreateErr: 'Failed to create superadmin',
    alertNoChanges: 'No changes detected',
    alertSaUpdated: 'Superadmin updated',
    alertSaUpdateErr: 'Failed to update superadmin',
    alertSaDeleted: 'Superadmin deleted',
    alertSaDeleteErr: 'Failed to delete superadmin',
    alertFillRequired: 'Fill in all required fields',
    alertProjectDeleted: 'Project deleted',
    alertProjectCreateErr: 'Failed to create project',
    alertProjectDeleteErr: 'Failed to delete project',
    alertPickUidSa: 'Select UID and superadmin',
    alertAssigned: 'UID assigned to superadmin',
    alertAssignErr: 'Failed to assign UID',
    alertUnassigned: 'Assignment removed',
    alertUnassignErr: 'Failed to remove assignment',
    projectCreatedFallback: 'Project created',
    billingTopUpBtn: 'Balance',
    billingTopUpTitle: 'Top up balance',
    billingTopUpCurrent: 'Current balance',
    billingTopUpAmount: 'Amount (USD)',
    billingTopUpNote: 'Note (optional)',
    billingTopUpSubmit: 'Top up',
    billingTopUpOk: 'Balance topped up',
    billingTopUpFailed: 'Top-up failed',
    billingTopUpLoadFailed: 'Failed to load balance',
    billingTopUpAmountInvalid: 'Enter a positive amount',
  },
};

/** Strings for UID management → Tags tab (EN / UK). */
const UID_TAGS_TAB = {
  uk: {
    tabPlc: 'Теги ПЛК',
    tabLocal: 'Локальні теги',
    searchNameDescr: 'Пошук за імʼям / описом',
    dataType: 'Тип даних',
    allTypes: 'Усі типи',
    tagsTitle: 'Теги',
    importDelta: 'Дельта (оновити й додати)',
    importReplace: 'Повна заміна',
    replaceWarn:
      'Повна заміна видалить усі теги. Потрібно перепривʼязати списки, аварії та тренди.',
    importCsv: 'Імпорт CSV',
    exportCsv: 'Експорт CSV',
    createLocal: 'Локальний тег',
    createTag: 'Створити тег',
    colVar: 'Імʼя змінної',
    colDescr: 'Опис',
    colDataType: 'Тип даних',
    colUnit: 'Одиниця',
    colAddress: 'Адреса',
    colBit: 'Біт',
    colLength: 'Довжина',
    colLimit: 'Ліміт',
    actions: 'Дії',
    yes: 'Так',
    no: 'Ні',
    emptyAll: 'Тегів не знайдено',
    emptyFilter: 'Немає тегів за фільтром',
    editTitle: 'Редагування тегу',
    varName: 'Імʼя змінної',
    varNameHelp: 'Лише латиниця, цифри та підкреслення',
    descrSystem: 'Назва змінної в системі',
    formula: 'Формула',
    formulaHelp: 'Приклад: (tag1 + tag2 + tag3) / 3',
    unit: 'Одиниця вимірювання',
    packetOffset: 'Адреса в пакеті',
    packetOffsetHelp: 'Зміщення в байтах від початку DATA. Для слова: offset = word × 2',
    packetLength: 'Довжина в пакеті',
    packetLengthBits: 'Обчислюється з бітових полів',
    packetLengthByType: 'Визначається типом даних',
    bitStart: 'Початковий біт',
    bitEnd: 'Кінцевий біт',
    bitEndHelp: '0..15 (порожньо — 1 біт)',
    bitsRange: '0..15',
    scaleCoeff: 'Коефіцієнт (ΔSCADA/ΔPLC)',
    scaleCoeffHelp: '(scada_max - scada_min) / (plc_max - plc_min)',
    precision: 'Точність (знаків після коми)',
    limitAfterScale: 'Обмежувати значення після масштабування',
    save: 'Зберегти',
    showHelp: 'Показати довідку',
    hideHelp: 'Сховати довідку',
    helpLine1:
      'Декодування починається з секції DATA. Поля packet_offset і packet_length — у байтах від початку DATA.',
    helpLine2:
      'Формат TCP-заголовка: -TD + NUM(1 байт hex, ASCII) + LEN_UID(1 байт hex, ASCII) + UID(LEN_UID байт, ASCII) + LEN_DATA(1 байт hex, ASCII) + DATA(hex) + ENTER(\\r).',
    errLoad: 'Помилка завантаження тегів',
    tagCreated: 'Тег створено',
    tagLocalCreated: 'Локальний тег створено',
    tagUpdated: 'Тег оновлено',
    tagDeleted: 'Тег видалено',
    confirmDelete: 'Видалити цей тег?',
    errCreate: 'Помилка створення тегу',
    errCreateLocal: 'Помилка створення локального тегу',
    errSave: 'Помилка збереження тегу',
    errDelete: 'Помилка видалення тегу',
    errImport: 'Помилка імпорту CSV',
    exportNoTags: 'Немає тегів для експорту',
    importSummary:
      'Імпорт завершено: створено {{created}}, оновлено {{updated}}, пропущено {{skipped}}, помилок {{errors}}{{detail}}',
    tagDescrDefault: 'Тег {{name}}',
    tagDescrLocalDefault: 'Локальний тег {{name}}',
    typeChar: 'Символ (char)',
    typeUchar: 'Символ (uchar)',
    typeInt: 'Ціле (int)',
    typeUint: 'Ціле (uint)',
    typeBool: 'Логічне (bool)',
    typeLocal: 'Локальне (formula)',
    typeFloat: 'Float',
    typeLong: 'Long',
    typeUlong: 'ULong',
    typeDouble: 'Double',
    typeString: 'Рядок (string)',
    uintBitSlice: ', зріз бітів',
    valEnterVar: 'Введіть імʼя змінної',
    valVarPattern: 'Імʼя змінної: лише латиниця, цифри та підкреслення',
    valEnterDescr: 'Введіть назву змінної в системі',
    valPacketOffset: 'Введіть адресу в пакеті',
    valPlcRange: 'PLC max не має збігатися з PLC min',
    valFormula: 'Введіть формулу для локального тегу',
    help: {
      tagTypesTitle: 'Теги ПЛК і локальні теги',
      tagTypes: [
        'Теги ПЛК читаються з пакета за адресою та довжиною в секції DATA. Локальні теги адреси не мають — вони обчислюються за формулою вже після декодування пакета.',
        'Теги — перший крок налаштування: списки, аварії, тренди та картки посилаються саме на них. Тег, який ніде не використовується, просто нікуди не потрапляє.',
      ],
      formulaTitle: 'Формула локального тегу',
      formula: [
        'Підтримуються + - * /, дужки й унарний мінус. Імена в формулі — це імена інших тегів; значення беруться з поточного декодованого пакета.',
        'Формули рахуються до трьох проходів поспіль, тому локальний тег може посилатися на інший локальний тег. Якщо якесь імʼя не має числового значення або трапилося ділення на нуль, тег цього циклу просто не оновлюється — старе значення залишається.',
      ],
    },
  },
  en: {
    tabPlc: 'PLC tags',
    tabLocal: 'Local tags',
    searchNameDescr: 'Search by name or description',
    dataType: 'Data type',
    allTypes: 'All types',
    tagsTitle: 'Tags',
    importDelta: 'Delta (update and add)',
    importReplace: 'Full replace',
    replaceWarn:
      'Full replace removes all tags. Re-link lists, alarms, and trends.',
    importCsv: 'Import CSV',
    exportCsv: 'Export CSV',
    createLocal: 'Local tag',
    createTag: 'Create tag',
    colVar: 'Variable name',
    colDescr: 'Description',
    colDataType: 'Data type',
    colUnit: 'Unit',
    colAddress: 'Address',
    colBit: 'Bit',
    colLength: 'Length',
    colLimit: 'Limit',
    actions: 'Actions',
    yes: 'Yes',
    no: 'No',
    emptyAll: 'No tags yet',
    emptyFilter: 'No tags match the filters',
    editTitle: 'Edit tag',
    varName: 'Variable name',
    varNameHelp: 'English letters, digits, and underscore only',
    descrSystem: 'System name (description)',
    formula: 'Formula',
    formulaHelp: 'Example: (tag1 + tag2 + tag3) / 3',
    unit: 'Unit',
    packetOffset: 'Packet address',
    packetOffsetHelp: 'Byte offset from start of DATA. For word index: offset = word × 2',
    packetLength: 'Length in packet',
    packetLengthBits: 'Derived from bit fields',
    packetLengthByType: 'Determined by data type',
    bitStart: 'Start bit',
    bitEnd: 'End bit',
    bitEndHelp: '0..15 (empty = 1 bit)',
    bitsRange: '0..15',
    scaleCoeff: 'Scale (ΔSCADA/ΔPLC)',
    scaleCoeffHelp: '(scada_max - scada_min) / (plc_max - plc_min)',
    precision: 'Decimal places',
    limitAfterScale: 'Clamp value after scaling',
    save: 'Save',
    showHelp: 'Show help',
    hideHelp: 'Hide help',
    helpLine1:
      'Decoding starts at the DATA section. packet_offset and packet_length are in bytes from the start of DATA.',
    helpLine2:
      'TCP header: -TD + NUM(1 byte hex, ASCII) + LEN_UID(1 byte hex, ASCII) + UID(LEN_UID bytes, ASCII) + LEN_DATA(1 byte hex, ASCII) + DATA(hex) + ENTER(\\r).',
    errLoad: 'Failed to load tags',
    tagCreated: 'Tag created',
    tagLocalCreated: 'Local tag created',
    tagUpdated: 'Tag updated',
    tagDeleted: 'Tag deleted',
    confirmDelete: 'Delete this tag?',
    errCreate: 'Failed to create tag',
    errCreateLocal: 'Failed to create local tag',
    errSave: 'Failed to save tag',
    errDelete: 'Failed to delete tag',
    errImport: 'CSV import failed',
    exportNoTags: 'No tags to export',
    importSummary:
      'Import finished: created {{created}}, updated {{updated}}, skipped {{skipped}}, errors {{errors}}{{detail}}',
    tagDescrDefault: 'Tag {{name}}',
    tagDescrLocalDefault: 'Local tag {{name}}',
    typeChar: 'Char',
    typeUchar: 'UChar',
    typeInt: 'Integer (int)',
    typeUint: 'Integer (uint)',
    typeBool: 'Boolean',
    typeLocal: 'Local (formula)',
    typeFloat: 'Float',
    typeLong: 'Long',
    typeUlong: 'ULong',
    typeDouble: 'Double',
    typeString: 'String',
    uintBitSlice: ', bit slice',
    valEnterVar: 'Enter variable name',
    valVarPattern: 'Use only English letters, digits, and underscore',
    valEnterDescr: 'Enter system description',
    valPacketOffset: 'Enter packet address',
    valPlcRange: 'PLC max must differ from PLC min',
    valFormula: 'Enter formula for local tag',
    help: {
      tagTypesTitle: 'PLC tags and local tags',
      tagTypes: [
        'PLC tags are read from the packet by address and length inside the DATA section. Local tags have no address — they are computed from a formula after the packet is decoded.',
        'Tags are the first configuration step: lists, alarms, trends and cards all reference them. A tag nobody references simply goes nowhere.',
      ],
      formulaTitle: 'Local tag formula',
      formula: [
        'Supports + - * /, parentheses and unary minus. Names in the formula are other tag names; values come from the packet being decoded.',
        'Formulas run up to three passes in a row, so a local tag may reference another local tag. If a name has no numeric value, or a division by zero happens, the tag is simply not updated this cycle and keeps its previous value.',
      ],
    },
  },
};

const UID_STATIONS_TAB = {
  uk: {
    searchNameNum: 'Пошук за назвою / номером',
    stationsTitle: 'Станції',
    colNum: 'Номер',
    colName: 'Назва',
    colDescription: 'Опис',
    colTimeout: 'Таймаут (сек)',
    actions: 'Дії',
    emptyAll: 'Станцій не знайдено',
    emptyFilter: 'Немає станцій за фільтром',
    createStation: 'Створити станцію',
    dlgEdit: 'Редагування станції',
    dlgCreate: 'Створення станції',
    stationName: 'Назва станції',
    stationDescription: 'Опис станції',
    descriptionHelper: 'Доступно у картках як <UID.description[номер станції]>',
    stationNum: 'Номер станції',
    timeoutSec: 'Таймаут (сек)',
    cancel: 'Скасувати',
    save: 'Зберегти',
    errLoad: 'Помилка завантаження станцій',
    valName: 'Введіть назву станції',
    valNum: 'Введіть номер станції',
    stationUpdated: 'Станцію оновлено',
    stationCreated: 'Станцію створено',
    errSave: 'Помилка збереження станції',
    confirmDelete: 'Видалити цю станцію?',
    stationDeleted: 'Станцію видалено',
    errDelete: 'Помилка видалення станції',
    telegramSection: 'Telegram (шаблони)',
    telegramConnectionLost: 'Повідомлення про втрату зв\'язку',
    telegramConnectionRestored: 'Повідомлення про відновлення зв\'язку',
    telegramTemplateHelper:
      'Порожньо = стандартне повідомлення. Токени: <station_name>, <time>, <tag>, <tag.unit>; cross-UID як у картках: <UID_A.tag_c[0]> (станція аварії), <UID_B.tag_c[2]> (інший UID — явний номер); проектні: <global.var>',
    stationDialogTabMain: 'Станція',
    stationDialogTabTelegram: 'Telegram',
    tgStationIntro:
      'Шаблони для цієї станції. Порожньо = стандартний текст про втрату/відновлення зв\'язку.',
    tgStationLostHelper: 'Надсилається при timeout станції.',
    tgStationRestoredHelper: 'Надсилається при першому пакеті після втрати зв\'язку.',
    tgTokenReference: 'Довідник токенів',
    help: {
      stationsTitle: 'Станції',
      stations: [
        'Видалення прибирає лише рядок станції в каталозі. Події та тренди в базі проекту цим не видаляються.',
        'Нові пакети з номером видаленої станції відкидаються, доки станцію з тим самим номером не створять знову.',
      ],
      numTitle: 'Номер станції',
      num: [
        'Має збігатися з номером у пакеті контролера. Допустимий діапазон пакета — 1..255; якщо станції з таким номером немає, пакет відкидається.',
        'Пошук іде за парою «UID + номер», тож дві станції з одним номером конфліктують: сервер бере один із рядків. Той самий номер — індекс у токенах карток, наприклад <UID.tag[номер]>. Якщо в UID задано max_stations і ліміт вичерпано, створення відхиляється.',
      ],
      timeoutTitle: 'Таймаут зв\'язку',
      timeout: [
        'Значення зберігається в полі sort, і перевірка зв\'язку трактує його як хвилини, попри підпис «сек». 0 або порожнє — 2 хвилини; значення від 1 і менше ніж 2 піднімається до 2 хвилин.',
        'Перевірка йде кожні 15 секунд від часу останнього пакета. Якщо пакет не прийшов у цей строк, створюється подія втрати зв\'язку.',
      ],
      coordsTitle: 'Координати на карті',
      coords: [
        'Порожнє поле зберігається як відсутні координати. Потрібні обидва числа: якщо заповнена лише широта або лише довгота, точка на карту не потрапить.',
        'Коли з шаблону генеруються картки станцій, ці координати записуються в картку і вмикають маркер, перезаписуючи координати, які вже були на картці.',
      ],
    },
  },
  en: {
    searchNameNum: 'Search by name or number',
    stationsTitle: 'Stations',
    colNum: 'Number',
    colName: 'Name',
    colDescription: 'Description',
    colTimeout: 'Timeout (sec)',
    actions: 'Actions',
    emptyAll: 'No stations yet',
    emptyFilter: 'No stations match the filter',
    createStation: 'Create station',
    dlgEdit: 'Edit station',
    dlgCreate: 'Create station',
    stationName: 'Station name',
    stationDescription: 'Station description',
    descriptionHelper: 'Available in cards as <UID.description[station number]>',
    stationNum: 'Station number',
    timeoutSec: 'Timeout (sec)',
    cancel: 'Cancel',
    save: 'Save',
    errLoad: 'Failed to load stations',
    valName: 'Enter station name',
    valNum: 'Enter station number',
    stationUpdated: 'Station updated',
    stationCreated: 'Station created',
    errSave: 'Failed to save station',
    confirmDelete: 'Delete this station?',
    stationDeleted: 'Station deleted',
    errDelete: 'Failed to delete station',
    telegramSection: 'Telegram templates',
    telegramConnectionLost: 'Connection lost message',
    telegramConnectionRestored: 'Connection restored message',
    telegramTemplateHelper:
      'Leave empty for the default message. Tokens: <station_name>, <time>, <tag>, <tag.unit>; cross-UID like cards: <UID_A.tag_c[0]> (alarm station), <UID_B.tag_c[2]> (other UID — explicit station); project: <global.var>',
    stationDialogTabMain: 'Station',
    stationDialogTabTelegram: 'Telegram',
    tgStationIntro:
      'Templates for this station. Empty = built-in connection lost/restored text.',
    tgStationLostHelper: 'Sent when the station connection times out.',
    tgStationRestoredHelper: 'Sent on the first packet after connection loss.',
    tgTokenReference: 'Token reference',
    help: {
      stationsTitle: 'Stations',
      stations: [
        'Deleting a station removes only its catalog row. Events and trends in the project database are left in place.',
        'New packets for a deleted station number are dropped until a station with that number is created again.',
      ],
      numTitle: 'Station number',
      num: [
        'Must match the station number in the controller packet. Packets allow 1..255; if no station has that number, the packet is dropped.',
        'Lookup is by UID plus number, so two stations with the same number collide and the server uses one of the rows. The same number is the index in card tokens such as <UID.tag[number]>. If the UID has max_stations and the limit is reached, creation is rejected.',
      ],
      timeoutTitle: 'Connection timeout',
      timeout: [
        'The value is stored in sort, and the connection check treats it as minutes even though the label says seconds. 0 or empty means 2 minutes; a value greater than 0 and below 2 is raised to 2 minutes.',
        'The check runs every 15 seconds from the last packet. If no packet arrives within that window, a connection-loss event is created.',
      ],
      coordsTitle: 'Map coordinates',
      coords: [
        'An empty field is stored as missing coordinates. Both numbers are required: latitude or longitude alone does not place a point on the map.',
        'When station cards are generated from a template, these coordinates are written onto the card and turn the marker on, overwriting coordinates the card already had.',
      ],
    },
  },
};

const UID_ALARM_RULES_TAB = {
  uk: {
    tabGroups: 'Групи аварій',
    tabRules: 'Правила групи',
    tabTelegramReset: 'Telegram — квитування',
    groupsTitle: 'Групи аварій',
    createGroup: 'Створити групу',
    exportCsv: 'Експорт CSV',
    exportNoGroups: 'Немає груп для експорту',
    importCsv: 'Імпорт CSV',
    importSummary: 'Імпорт завершено: створено {{created}}, оновлено {{updated}}, помилок {{errors}}',
    importErrorsTitle: 'Помилки імпорту CSV',
    importErrorsSummary: 'Створено: {{created}}, оновлено: {{updated}}, помилок: {{errors}}',
    importErrorColLine: 'Рядок',
    importErrorColReason: 'Причина',
    errImport: 'Помилка імпорту CSV',
    colName: 'Назва',
    colType: 'Тип',
    colTag: 'Тег',
    colDefaultSeverity: 'Важність за замовчуванням',
    colRulesCount: 'Правил',
    colThresholdOrBit: 'Пороги / біт',
    colSeverity: 'Важність',
    actions: 'Дії',
    emptyGroups: 'Групи аварій не знайдено',
    rulesSubtitle: 'Правила групи',
    typeSummary: 'Тип: {{type}} | Тег: {{tag}}',
    backToGroups: 'Назад до груп',
    addRule: 'Додати правило',
    emptyRules: 'Правил не знайдено',
    ruleBit: 'Біт {{n}}',
    severityError: 'Помилка',
    severityWarning: 'Попередження',
    typeThreshold: 'Порогове',
    typeBitmask: 'Бітова маска',
    dlgGroupCreate: 'Створення групи',
    dlgGroupEdit: 'Редагування групи',
    groupName: 'Назва групи',
    groupNameHint: 'Наприклад: порогові tag_1',
    groupType: 'Тип групи',
    tag: 'Тег',
    defaultSeverity: 'Важність за замовчуванням',
    dlgRuleCreate: 'Створення правила',
    dlgRuleEdit: 'Редагування правила',
    ruleName: 'Назва правила',
    severity: 'Важність',
    thresholdMin: 'Мінімум (>=)',
    thresholdMax: 'Максимум (<=)',
    thresholdHelper:
      'Діапазон з включними межами: min..max. Якщо однієї межі немає, використовується -/+ нескінченність.',
    bitOffset: 'Зміщення біта',
    cancel: 'Скасувати',
    save: 'Зберегти',
    errLoad: 'Помилка завантаження правил аварій',
    enterGroupName: 'Введіть назву групи',
    pickTag: 'Оберіть тег',
    noRulesToUpdate: 'У групі немає правил для оновлення',
    groupUpdated: 'Групу оновлено',
    groupCreated: 'Групу створено',
    errSaveGroup: 'Помилка збереження групи',
    confirmDeleteGroup:
      'Видалити групу «{{name}}»? Усі правила групи також будуть видалені.',
    groupDeleted: 'Групу видалено',
    errDeleteGroup: 'Помилка видалення групи',
    pickGroup: 'Оберіть групу',
    enterRuleName: 'Введіть назву правила',
    thresholdNeedBound: 'Вкажіть хоча б одну межу (low або high)',
    thresholdOrder: 'Верхня межа має бути більшою за нижню',
    specifyBit: 'Вкажіть зміщення біта',
    ruleUpdated: 'Правило оновлено',
    ruleCreated: 'Правило створено',
    errSaveRule: 'Помилка збереження правила',
    confirmDeleteRule: 'Видалити це правило?',
    ruleDeleted: 'Правило видалено',
    errDeleteRule: 'Помилка видалення правила',
    defaultRuleName: 'правило {{n}}',
    telegramSection: 'Telegram (шаблони)',
    telegramOpen: 'Повідомлення про відкриття',
    telegramClose: 'Повідомлення про закриття',
    telegramPartial: 'Часткове квитування',
    telegramAlarmTemplateHelper:
      'Порожньо = стандартне. Системні: <station_name>, <alarm_name>, <time>, <remaining_alarms>. Локальний тег: <tag_c>. Cross-UID: <UID_A.tag_c[0]> — тег зі станції аварії; <UID_B.tag_c[2]> — інший UID, номер станції обовʼязковий (>0). Проектні: <global.var>',
    ruleDialogTabRule: 'Правило',
    ruleDialogTabTelegram: 'Telegram',
    tgIntro:
      'Кастомні шаблони замінюють стандартні повідомлення в Telegram. Якщо поле порожнє — використовується текст за замовчуванням.',
    tgIntroNote:
      'Відкриття — для кожного правила окремо. Спільні шаблони часткового та повного квитування — вкладка «Telegram — квитування».',
    tgTabOpen: 'Відкриття',
    tgTabClose: 'Повне квитування',
    tgTabPartial: 'Часткове квитування',
    tgOpenHelper: 'Надсилається один раз при новому відкритті цієї аварії.',
    tgRuleCloseHelper:
      'Необов\'язково. Порожньо = спільний шаблон з вкладки «Telegram — квитування».',
    tgCloseHelper: 'Коли на станції квитовано останню аварію. Порожньо = стандарт.',
    tgPartialHelper:
      'Спільний для всіх правил UID. Токени: <station_name>, <alarm_name>, <remaining_alarms>, <time>.',
    tgUidDefaultsTitle: 'Спільні шаблони квитування (весь UID)',
    tgUidDefaultsIntro:
      'Один шаблон на всі правила. Часткове — квитовано одну аварію, на станції ще є інші. Повне — активних аварій не лишилось.',
    tgUidDefaultsSaved: 'Шаблони квитування збережено',
    tgUidDefaultsSaveError: 'Помилка збереження шаблонів квитування',
    tgTokenReference: 'Довідник токенів',
    tgTokenStation: 'назва станції аварії',
    tgTokenLocalTag: 'тег цієї станції (короткий запис)',
    tgTokenSameUid: 'тег свого UID, станція аварії',
    tgTokenOtherUid: 'тег іншого UID, номер станції обовʼязковий',
    tgTokenProject: 'проектний тег (формула)',
    tgTokenRemaining: 'список аварій, що залишились (шаблони квитування)',
    tgPreviewRemainingSample: 'alarm bit1, ALARMS: alarm bit1',
    tabTelegram: 'Telegram шаблони',
    tgProjectDefaultsTitle: 'Спільні шаблони проекту',
    tgProjectDefaultsIntro:
      'Дефолтні тексти для проектних аварій/попереджень. Окреме правило може перевизначити відкриття або квитування.',
    tgProjectDefaultsSaved: 'Шаблони проекту збережено',
    tgProjectDefaultsSaveError: 'Помилка збереження шаблонів проекту',
    tgProjectOpenHelper: 'Надсилається один раз при новому спрацюванні правила.',
    tgProjectCloseHelper:
      'Коли правило перестало спрацьовувати. Порожньо = спільний шаблон з вкладки «Telegram шаблони».',
    help: {
      groupsTitle: 'Групи аварій',
      groups: [
        'Група — це набір правил для одного тега. Окремої сутності «група» в базі немає: групи збираються з правил за ознакою «тег + назва групи + тип».',
        'Тому створення групи одразу створює перше правило-заготовку, а видалення групи видаляє всі її правила.',
      ],
      csvTitle: 'Імпорт / експорт CSV',
      csv: [
        'Розділювач — крапка з комою. Перша колонка порожня, далі row_type: рядок GROUP задає групу, наступні рядки RULE належать до неї.',
        'Експорт пропускає групи, тег яких не вдалося визначити за назвою. Після імпорту показується звіт: створено, оновлено та список помилок по рядках.',
      ],
      groupTypeTitle: 'Тип групи',
      groupType: [
        'Порогове — правило спрацьовує, коли значення тега потрапляє в діапазон min..max. Бітова маска — правило стежить за одним бітом у значенні тега.',
        'Зміна типу існуючої групи перезапише всі її правила: пороги скинуться на 0..100, зміщення біта — на 0.',
      ],
      tagTitle: 'Тег групи',
      tag: 'Тег, за значенням якого працюють усі правила групи. Теги створюються на вкладці «Теги» — якщо потрібного немає в списку, спершу додайте його там. Зміна тега застосується до всіх правил групи одразу.',
      defaultSeverityTitle: 'Важність за замовчуванням',
      defaultSeverity: [
        'Застосовується лише до першого правила, яке створюється разом із групою. Для вже існуючих правил діє важність самого правила.',
        'Для порогових груп важність також визначає тип правила: THRESHOLD_ALARM_HIGH для помилки, THRESHOLD_WARN_HIGH для попередження.',
      ],
      ruleSeverityTitle: 'Важність правила',
      ruleSeverity: 'Важність саме цього правила — вона перекриває важність за замовчуванням, задану на рівні групи.',
      bitOffsetTitle: 'Зміщення біта',
      bitOffset: 'Номер біта у значенні тега, від 0 до 15, де 0 — молодший біт. Правило спрацьовує, коли цей біт встановлено в 1.',
    },
  },
  en: {
    tabGroups: 'Alarm groups',
    tabRules: 'Group rules',
    tabTelegramReset: 'Telegram — acknowledgement',
    groupsTitle: 'Alarm groups',
    createGroup: 'Create group',
    exportCsv: 'Export CSV',
    exportNoGroups: 'No groups to export',
    importCsv: 'Import CSV',
    importSummary: 'Import finished: created {{created}}, updated {{updated}}, errors {{errors}}',
    importErrorsTitle: 'CSV import errors',
    importErrorsSummary: 'Created: {{created}}, updated: {{updated}}, errors: {{errors}}',
    importErrorColLine: 'Line',
    importErrorColReason: 'Reason',
    errImport: 'CSV import failed',
    colName: 'Name',
    colType: 'Type',
    colTag: 'Tag',
    colDefaultSeverity: 'Default severity',
    colRulesCount: 'Rules',
    colThresholdOrBit: 'Thresholds / bit',
    colSeverity: 'Severity',
    actions: 'Actions',
    emptyGroups: 'No alarm groups',
    rulesSubtitle: 'Group rules',
    typeSummary: 'Type: {{type}} | Tag: {{tag}}',
    backToGroups: 'Back to groups',
    addRule: 'Add rule',
    emptyRules: 'No rules',
    ruleBit: 'Bit {{n}}',
    severityError: 'Error',
    severityWarning: 'Warning',
    typeThreshold: 'Threshold',
    typeBitmask: 'Bitmask',
    dlgGroupCreate: 'Create group',
    dlgGroupEdit: 'Edit group',
    groupName: 'Group name',
    groupNameHint: 'e.g. thresholds tag_1',
    groupType: 'Group type',
    tag: 'Tag',
    defaultSeverity: 'Default severity',
    dlgRuleCreate: 'Create rule',
    dlgRuleEdit: 'Edit rule',
    ruleName: 'Rule name',
    severity: 'Severity',
    thresholdMin: 'Minimum (>=)',
    thresholdMax: 'Maximum (<=)',
    thresholdHelper:
      'Inclusive range: min..max. If a bound is empty, -/+ infinity is used.',
    bitOffset: 'Bit offset',
    cancel: 'Cancel',
    save: 'Save',
    errLoad: 'Failed to load alarm rules',
    enterGroupName: 'Enter group name',
    pickTag: 'Select a tag',
    noRulesToUpdate: 'No rules in this group to update',
    groupUpdated: 'Group updated',
    groupCreated: 'Group created',
    errSaveGroup: 'Failed to save group',
    confirmDeleteGroup: 'Delete group "{{name}}"? All rules in the group will be removed.',
    groupDeleted: 'Group deleted',
    errDeleteGroup: 'Failed to delete group',
    pickGroup: 'Select a group',
    enterRuleName: 'Enter rule name',
    thresholdNeedBound: 'Set at least one bound (low or high)',
    thresholdOrder: 'High bound must be greater than low',
    specifyBit: 'Specify bit offset',
    ruleUpdated: 'Rule updated',
    ruleCreated: 'Rule created',
    errSaveRule: 'Failed to save rule',
    confirmDeleteRule: 'Delete this rule?',
    ruleDeleted: 'Rule deleted',
    errDeleteRule: 'Failed to delete rule',
    defaultRuleName: 'rule {{n}}',
    telegramSection: 'Telegram templates',
    telegramOpen: 'Open message',
    telegramClose: 'Close message',
    telegramPartial: 'Partial acknowledgement',
    telegramAlarmTemplateHelper:
      'Leave empty for default. System: <station_name>, <alarm_name>, <time>, <remaining_alarms>. Local tag: <tag_c>. Cross-UID: <UID_A.tag_c[0]> = alarm station; <UID_B.tag_c[2]> = other UID, explicit station (>0) required. Project: <global.var>',
    ruleDialogTabRule: 'Rule',
    ruleDialogTabTelegram: 'Telegram',
    tgIntro:
      'Custom templates replace default Telegram messages. Empty field = built-in default text.',
    tgIntroNote:
      'Open — per rule. Shared partial/full acknowledgement templates — «Telegram — acknowledgement» tab on this screen.',
    tgTabOpen: 'Open',
    tgTabClose: 'Full acknowledgement',
    tgTabPartial: 'Partial acknowledgement',
    tgOpenHelper: 'Sent once when this alarm newly opens.',
    tgRuleCloseHelper:
      'Optional. Empty = shared template from the «Telegram — acknowledgement» tab.',
    tgCloseHelper: 'When the last alarm on the station is acknowledged. Empty = default.',
    tgPartialHelper:
      'Shared for all UID rules. Tokens: <station_name>, <alarm_name>, <remaining_alarms>, <time>.',
    tgUidDefaultsTitle: 'Shared acknowledgement templates (whole UID)',
    tgUidDefaultsIntro:
      'One template for all rules. Partial — one alarm acknowledged, others remain. Full — no active alarms left.',
    tgUidDefaultsSaved: 'Acknowledgement templates saved',
    tgUidDefaultsSaveError: 'Failed to save acknowledgement templates',
    tgTokenReference: 'Token reference',
    tgTokenStation: 'alarm station name',
    tgTokenLocalTag: 'tag on alarm station (short form)',
    tgTokenSameUid: 'own UID tag, alarm station',
    tgTokenOtherUid: 'another UID tag, explicit station required',
    tgTokenProject: 'project tag (formula)',
    tgTokenRemaining: 'remaining active alarms (acknowledgement templates only)',
    tgPreviewRemainingSample: 'alarm bit1, ALARMS: alarm bit1',
    tabTelegram: 'Telegram templates',
    tgProjectDefaultsTitle: 'Shared project templates',
    tgProjectDefaultsIntro:
      'Default texts for project alarms/warnings. Individual rules can override open or acknowledgement.',
    tgProjectDefaultsSaved: 'Project templates saved',
    tgProjectDefaultsSaveError: 'Failed to save project templates',
    tgProjectOpenHelper: 'Sent once when this rule newly triggers.',
    tgProjectCloseHelper:
      'When the rule stops triggering. Empty = shared template from the Telegram templates tab.',
    help: {
      groupsTitle: 'Alarm groups',
      groups: [
        'A group is a set of rules for one tag. There is no separate group entity in the database: groups are derived from rules by tag + group name + type.',
        'That is why creating a group immediately creates a first placeholder rule, and deleting a group deletes all of its rules.',
      ],
      csvTitle: 'CSV import / export',
      csv: [
        'Semicolon-separated. The first column is empty, then row_type: a GROUP row defines the group, the RULE rows that follow belong to it.',
        'Export skips groups whose tag name could not be resolved. After import you get a report: created, updated and a per-line list of errors.',
      ],
      groupTypeTitle: 'Group type',
      groupType: [
        'Threshold — the rule triggers when the tag value falls into the min..max range. Bitmask — the rule watches a single bit of the tag value.',
        'Changing the type of an existing group rewrites all of its rules: thresholds reset to 0..100, bit offset resets to 0.',
      ],
      tagTitle: 'Group tag',
      tag: 'The tag every rule in this group evaluates. Tags are created on the Tags tab — if the one you need is missing, add it there first. Changing the tag applies to all rules in the group at once.',
      defaultSeverityTitle: 'Default severity',
      defaultSeverity: [
        'Applies only to the first rule created together with the group. Existing rules keep their own severity.',
        'For threshold groups severity also picks the rule type: THRESHOLD_ALARM_HIGH for error, THRESHOLD_WARN_HIGH for warning.',
      ],
      ruleSeverityTitle: 'Rule severity',
      ruleSeverity: 'Severity of this particular rule — it overrides the default severity set at group level.',
      bitOffsetTitle: 'Bit offset',
      bitOffset: 'Bit number inside the tag value, 0 to 15, where 0 is the least significant bit. The rule triggers when this bit is set to 1.',
    },
  },
};

const UID_TREND_CONFIGS_TAB = {
  uk: {
    filterByTag: 'Фільтр за тегом',
    allTags: 'Усі теги',
    trendsTitle: 'Налаштування трендів',
    createConfig: 'Створити налаштування',
    colTag: 'Тег',
    colTrended: 'Трендується',
    colPeriod: 'Період (сек)',
    colDeadband: 'Deadband',
    actions: 'Дії',
    emptyConfigs: 'Налаштувань не знайдено',
    dlgEdit: 'Редагувати налаштування',
    dlgCreate: 'Створити налаштування',
    tag: 'Тег',
    trendEnabled: 'Трендування увімкнено',
    minPeriod: 'Мінімальний період (секунди)',
    minPeriodPositive: 'Має бути додатним числом',
    deadband: 'Deadband',
    deadbandNonneg: 'Має бути невідʼємним числом',
    cancel: 'Скасувати',
    save: 'Зберегти',
    errLoad: 'Помилка завантаження налаштувань трендів',
    pickTag: 'Оберіть тег',
    minPeriodErr: 'Мінімальний період має бути додатним числом',
    deadbandErr: 'Deadband має бути невідʼємним числом',
    updated: 'Налаштування оновлено',
    created: 'Налаштування створено',
    errSave: 'Помилка збереження налаштування',
    confirmDelete: 'Видалити це налаштування?',
    deleted: 'Налаштування видалено',
    errDelete: 'Помилка видалення налаштування',
    yes: 'Так',
    no: 'Ні',
    help: {
      trendsTitle: 'Налаштування трендів',
      trends: [
        'Одне налаштування на тег. Теги без налаштування в тренди не пишуться взагалі.',
        'Запис іде пакетом: один зріз часу на всі увімкнені теги станції, з періодом із налаштувань трендів UID (trend_settings.period_seconds, за замовчуванням 60 с). Поки станція офлайн, зрізи не пишуться.',
      ],
      trendEnabledTitle: 'Трендування увімкнено',
      trendEnabled: 'Єдиний перемикач, який реально впливає на запис: вимкнений тег пропускається під час формування зрізу.',
      minPeriodTitle: 'Мінімальний період',
      minPeriod: 'Увага: на запис трендів тегів UID це поле зараз не впливає — реальний період береться з налаштувань трендів UID і діє одразу на всю станцію. Поле зберігається в базі, але бекенд його не читає.',
      deadbandTitle: 'Deadband',
      deadband: 'Увага: фільтрації за мертвою зоною для тегів UID зараз немає — зріз пишеться цілком, незалежно від того, наскільки змінилося значення. Поле зберігається, але на запис не впливає.',
    },
  },
  en: {
    filterByTag: 'Filter by tag',
    allTags: 'All tags',
    trendsTitle: 'Trend settings',
    createConfig: 'Create setting',
    colTag: 'Tag',
    colTrended: 'Trending',
    colPeriod: 'Period (sec)',
    colDeadband: 'Deadband',
    actions: 'Actions',
    emptyConfigs: 'No settings',
    dlgEdit: 'Edit setting',
    dlgCreate: 'Create setting',
    tag: 'Tag',
    trendEnabled: 'Trending enabled',
    minPeriod: 'Minimum period (seconds)',
    minPeriodPositive: 'Must be a positive number',
    deadband: 'Deadband',
    deadbandNonneg: 'Must be non-negative',
    cancel: 'Cancel',
    save: 'Save',
    errLoad: 'Failed to load trend settings',
    pickTag: 'Select a tag',
    minPeriodErr: 'Minimum period must be positive',
    deadbandErr: 'Deadband must be non-negative',
    updated: 'Setting updated',
    created: 'Setting created',
    errSave: 'Failed to save setting',
    confirmDelete: 'Delete this setting?',
    deleted: 'Setting deleted',
    errDelete: 'Failed to delete setting',
    yes: 'Yes',
    no: 'No',
    help: {
      trendsTitle: 'Trend settings',
      trends: [
        'One setting per tag. Tags without a setting are never written to trends.',
        'Writes are batched: one timestamp for all enabled tags of a station, at the period from the UID trend settings (trend_settings.period_seconds, 60 s by default). Nothing is written while the station is offline.',
      ],
      trendEnabledTitle: 'Trending enabled',
      trendEnabled: 'The only switch that actually affects recording: a disabled tag is skipped when the batch is built.',
      minPeriodTitle: 'Minimum period',
      minPeriod: 'Heads-up: this field currently has no effect on UID tag trends — the real period comes from the UID trend settings and applies to the whole station. The value is stored but the backend never reads it.',
      deadbandTitle: 'Deadband',
      deadband: 'Heads-up: there is currently no deadband filtering for UID tags — the whole batch is written regardless of how much the value changed. The value is stored but does not affect recording.',
    },
  },
};

// Пока тут только справка: подписи самой вкладки ещё не локализованы.
const UID_COMMAND_TEMPLATES_TAB = {
  uk: {
    title: 'Шаблони команд',
    create: 'Створити шаблон',
    colName: 'Назва',
    colHex: 'HEX-тіло',
    colDescription: 'Опис',
    colPriority: 'Пріоритет',
    colCalc: 'Кальк.',
    actions: 'Дії',
    empty: 'Шаблони команд не знайдено',
    help: {
      templatesTitle: 'Шаблони команд',
      templates: [
        'Шаблон зберігається в каталозі UID і діє в усіх проектах, до яких цей UID прив’язаний.',
        'Видалення прибирає лише рядок шаблону. Кнопки карток і елементи груп кодів, які посилаються на цей id, залишаються: при натисканні сервер відповість, що шаблон не знайдено.',
      ],
      activeTitle: 'Активність',
      active: 'Вимкнений шаблон не віддається проекту і не надсилається: сервер відповідає, що шаблон неактивний.',
      calcTitle: 'Калькулятор',
      calc: [
        'Увімкнення вимагає тег. Вимкнення очищає прив’язку, і команда знову надсилає лише фіксоване HEX-тіло.',
        'Без числа від оператора відправка не проходить. HEX-тіло, підставлене клієнтом для такого шаблону, сервер ігнорує.',
      ],
      tagTitle: 'Тег калькулятора',
      tag: [
        'Число оператора — це значення SCADA. Для цілих типів спочатку застосовується precision тега, потім лінійний перерахунок із scada_min..scada_max у plc_min..plc_max. float і double передаються як є, без масштабу.',
        'До префікса з поля HEX сервер дописує packet_offset як uint16 big-endian (4 hex-символи, діапазон 0..65535) і байти значення за типом тега. Тег типу string відхиляється. Якщо в тега увімкнено ліміт, сире значення поза plc_min..plc_max теж відхиляється.',
      ],
      hexTitle: 'HEX-тіло',
      hex: [
        'Це лише секція DATA. Звичайний кадр: -TC, номер станції (1 байт), довжина UID (1 байт), UUID, довжина даних (1 байт), це тіло, кінець — символ CR. Секція даних довша за 255 байт відхиляється.',
        'Для тунельного UID кадр коротший: -TC, номер станції і тіло, без довжин і UUID, кінець — перевід рядка. Приклад на екрані завжди показує станцію 1 і звичайний кадр.',
      ],
    },
  },
  en: {
    title: 'Command templates',
    create: 'Create template',
    colName: 'Name',
    colHex: 'HEX body',
    colDescription: 'Description',
    colPriority: 'Priority',
    colCalc: 'Calc',
    actions: 'Actions',
    empty: 'No command templates',
    help: {
      templatesTitle: 'Command templates',
      templates: [
        'A template lives in the UID catalog and applies to every project that UID is attached to.',
        'Deleting removes only the template row. Card buttons and code-group items that still point at this id stay in place; pressing them gets a template-not-found error.',
      ],
      activeTitle: 'Active',
      active: 'A disabled template is not returned to the project and cannot be sent: the server answers that the template is inactive.',
      calcTitle: 'Calculator',
      calc: [
        'Turning this on requires a tag. Turning it off clears the binding, and the command sends only the fixed HEX body again.',
        'The send fails if the operator does not enter a number. A HEX body supplied by the client for this template is ignored.',
      ],
      tagTitle: 'Calculator tag',
      tag: [
        'The operator enters a SCADA value. Integer types are rounded to the tag precision, then scaled linearly from scada_min..scada_max into plc_min..plc_max. float and double are sent as-is, with no scaling.',
        'The server appends packet_offset as a big-endian uint16 (4 hex characters, range 0..65535) and then the value bytes for the tag type. A string tag is rejected. If the tag has limits enabled, a raw value outside plc_min..plc_max is rejected too.',
      ],
      hexTitle: 'HEX body',
      hex: [
        'This field is only the DATA section. A normal frame is -TC, station number (1 byte), UID length (1 byte), UUID, data length (1 byte), this body, then CR. A data section longer than 255 bytes is rejected.',
        'A tunnel UID uses a shorter frame: -TC, station number, and the body, with no lengths or UUID, ending in a newline. The on-screen example always shows station 1 and the normal frame.',
      ],
    },
  },
};

const UID_TELEGRAM_TAB = {
  uk: {
    help: {
      enabledTitle: 'Сповіщення UID',
      enabled: 'Це запасний бот UID. Якщо в проекті вже є бот, який підходить для цього UID і типу події, використовується він, а цей перемикач і токен не беруть участі. Без токена і хоча б одного chat_id повідомлення з цього UID все одно не піде.',
      tokenTitle: 'Токен бота',
      token: 'Порожнє поле зберігається як відсутній токен. Непорожній має бути у форматі Telegram: цифри, двокрапка і щонайменше 20 символів після неї. Тестова кнопка йде тим самим маршрутом, тож при збігу проектного бота тест прийде йому, а не сюди.',
      chatsTitle: 'Chat ID',
      chats: 'Порожні рядки при збереженні відкидаються. Кожен id — ціле число від 3 цифр, мінус на початку дозволений. Якщо після збереження список порожній, запасний бот UID нічого не надсилає.',
    },
  },
  en: {
    help: {
      enabledTitle: 'UID notifications',
      enabled: 'This is the UID fallback bot. If a project already has a bot that matches this UID and the event type, that bot is used and this switch and token are not. Without a token and at least one chat id, this UID still sends nothing.',
      tokenTitle: 'Bot token',
      token: 'An empty field is stored as no token. A non-empty value must be a Telegram token: digits, a colon, and at least 20 characters after it. The test button uses the same route, so a matching project bot receives the test instead of this token.',
      chatsTitle: 'Chat ID',
      chats: 'Blank rows are dropped on save. Each id is an integer of at least 3 digits; a leading minus is allowed. If the list is empty after save, the UID fallback bot sends nothing.',
    },
  },
};

const UID_SVG_TAB = {
  uk: {
    help: {
      configsTitle: 'SVG-конфігурації',
      configs: [
        'Ця вкладка пише в каталог UID. Мнемосхема читає копію в проекті: імпорт з каталогу додає нові імена і пропускає ті, що вже є, тож правка тут не оновлює вже імпортовану копію.',
        'Якщо картка не задала конкретний id, береться перша конфігурація проекту за назвою.',
      ],
      svgTitle: 'Вміст SVG',
      svg: [
        'Після зміни тексту сервер шукає теги в data-tag, data-var, у дужках {name} і в старому форматі через кому в f1, f2 та inkscape:label. Якщо розбір пройшов, вміст може бути замінений нормалізованою версією.',
        'Точний збіг імені тега в SVG з var тега UID заповнює мапінг і не затирає вже заданий. Вкладка мапінгу недоступна, поки вміст порожній.',
      ],
      rulesTitle: 'Правила відображення',
      rules: [
        'Поки JSON невалідний або це не масив, збереження блокується, а попередній масив лишається. Правило без selector, condition або action пропускається.',
        'Правила застосовуються від більшого priority до меншого, тож менше число перезаписує більше на тому самому атрибуті. Якщо priority не задано, це 0.',
      ],
      viewTitle: 'Режим перегляду',
      view: 'split показує мнемосхему і картку, svg_only ховає картку, card_only ховає мнемосхему. На проектній картці detail_svg_layout зі значенням split, svg_only або card_only перекриває це поле.',
      alertTitle: 'Попередження про SVG',
      alert: 'Прапорець увімкнено за замовчуванням, і попередження про відсутню мнемосхему не показується. Зніміть його, щоб попередження стало видимим.',
      mapTitle: 'Мапінг тегів',
      map: [
        'При збереженні з мапінгу викидаються системні імена status, statusColor, alarm, connection, isonline, activeAlarmsCount, hasAlarms, firstAlarmMessage і firstAlarmSeverity: рендер підставляє їх сам. alarmstr і lastOnline цей фільтр не чіпає.',
        'Якщо мапінг є, а значення тега порожнє, на мнемосхему підставляється 0.',
      ],
    },
  },
  en: {
    help: {
      configsTitle: 'SVG configs',
      configs: [
        'This tab writes to the UID catalog. The mimic reads the project copy: import from the catalog adds new names and skips names that already exist, so an edit here does not update a copy that was already imported.',
        'If the card does not set a specific id, the first project config by name is used.',
      ],
      svgTitle: 'SVG content',
      svg: [
        'After the text changes, the server looks for tags in data-tag, data-var, in braces {name}, and in the old comma format inside f1, f2, and inkscape:label. If parsing succeeds, the content may be replaced with a normalized version.',
        'An exact match between an SVG tag name and a UID tag var fills the mapping and does not overwrite one that is already set. The mapping tab stays disabled until the content is non-empty.',
      ],
      rulesTitle: 'Display rules',
      rules: [
        'While the JSON is invalid or is not an array, saving is blocked and the previous array stays. A rule without selector, condition, or action is skipped.',
        'Rules are applied from higher priority to lower, so the smaller number overwrites the larger one on the same attribute. A missing priority is 0.',
      ],
      viewTitle: 'View mode',
      view: 'split shows the mimic and the card, svg_only hides the card, card_only hides the mimic. On a project card, detail_svg_layout set to split, svg_only, or card_only overrides this field.',
      alertTitle: 'Missing SVG alert',
      alert: 'The box is on by default, and the missing-mimic warning is hidden. Clear it to make that warning visible.',
      mapTitle: 'Tag mapping',
      map: [
        'On save, the system names status, statusColor, alarm, connection, isonline, activeAlarmsCount, hasAlarms, firstAlarmMessage, and firstAlarmSeverity are removed from the mapping: the renderer fills them itself. alarmstr and lastOnline are not removed by this filter.',
        'If a mapping exists and the tag value is empty, the mimic gets 0.',
      ],
    },
  },
};

const UID_CARDS_TAB = {
  uk: {
    help: {
      cardsTitle: 'Картки UID',
      cards: 'Сторінка подробиць запитує шаблони з контекстом «Подробно» і бере перший за назвою. Якщо таких кілька, решта для цієї сторінки не використовується.',
      typeTitle: 'Тип компонента',
      type: [
        'Тип лише перемикає, яке JSON-поле показано. Інші об’єкти налаштувань лишаються в даних і теж зберігаються. Контекст використання при цьому не змінюється.',
        'Сітка в рендері з’являється тільки для типу «Картка» разом із layout grid. Типи «Таблиця» і «Список» малюються одним блоком.',
      ],
      usageTitle: 'Контекст використання',
      usage: 'Зберігається окремо від типу компонента. Сторінка подробиць відбирає саме значення details і сортує збіги за назвою.',
      jsonTitle: 'JSON налаштувань',
      jsonUnused: [
        'Невалідний JSON у цьому полі одразу скидає значення в порожнє. Якщо зберегти картку, поки текст ще не розібрався, збережене налаштування зітреться.',
        'Поточний рендер картки це поле не читає: значення лише зберігається в каталозі.',
      ],
      jsonList: [
        'Невалідний JSON одразу скидає значення в порожнє, і збереження в цей момент стирає налаштування. Поле замінює об’єкт list_settings цілком.',
        'Рендер читає цей об’єкт: вирівнювання тексту і правила стилю (style_rules, також styleRules або rules). Якщо в тексті немає text_align, вибір вирівнювання з об’єкта зникне.',
      ],
      layoutTitle: 'Layout',
      layout: 'Рендер порівнює це поле з словами grid і list. grid разом із типом «Картка» дає сітку на 2 колонки: окремого поля кількості колонок тут немає. list, порожнє та будь-який інший текст малюються одним блоком.',
      alignTitle: 'Вирівнювання тексту',
      align: 'Пишеться в list_settings.text_align, навіть коли на екрані відкрите інше JSON-поле. Рендер також приймає ключі textAlign і align; будь-що крім left, center і right стає центром.',
    },
  },
  en: {
    help: {
      cardsTitle: 'UID cards',
      cards: 'The details page requests templates whose usage context is details and uses the first one by name. If several match, the rest are not used on that page.',
      typeTitle: 'Component type',
      type: [
        'The type only switches which JSON field is shown. The other settings objects stay in the data and are still saved. It does not change the usage context.',
        'The renderer draws a grid only for type card together with layout grid. Types table and list are drawn as a single block.',
      ],
      usageTitle: 'Usage context',
      usage: 'Stored separately from the component type. The details page selects the value details and sorts matches by name.',
      jsonTitle: 'Settings JSON',
      jsonUnused: [
        'Invalid JSON in this field is immediately stored as empty. Saving the card while the text still does not parse wipes the saved setting.',
        'The current card renderer does not read this field: the value is only stored in the catalog.',
      ],
      jsonList: [
        'Invalid JSON is immediately stored as empty, and saving at that moment wipes the setting. The field replaces the whole list_settings object.',
        'The renderer reads this object for text alignment and style rules (style_rules, also styleRules or rules). If the text omits text_align, the alignment choice disappears from the object.',
      ],
      layoutTitle: 'Layout',
      layout: 'The renderer compares this field to the words grid and list. grid together with type card draws a 2-column grid: this form has no separate column-count field. list, empty, and any other text are drawn as a single block.',
      alignTitle: 'Text alignment',
      align: 'Written to list_settings.text_align even when another JSON field is on screen. The renderer also accepts the keys textAlign and align; anything other than left, center, and right becomes center.',
    },
  },
};

const UID_CODE_GROUPS_TAB = {
  uk: {
    tabProjectLists: 'Списки проєкту',
    tabItems: 'Елементи списку',
    listsTitle: 'Списки проєкту',
    createList: 'Створити список',
    colName: 'Назва',
    colType: 'Тип',
    colMode: 'Режим',
    colTarget: 'Ціль',
    actions: 'Дії',
    emptyLists: 'Списки не знайдено',
    help: {
      groupsTitle: 'Групи кодів',
      groups: [
        'Група кодів розшифровує числове значення тега в текст. Коли приходить пакет, бекенд шукає відповідний елемент і кладе його назву в поле «<група>_decoded», а якщо в елемента задано важність — ще й у «<група>_severity».',
        'Якщо жоден елемент не підійшов, поле «_decoded» не заповнюється взагалі — на картці залишиться порожнє місце, а не «невідомо».',
      ],
      valueModeTitle: 'Режим декодування',
      valueMode: [
        'Значення тега — елемент шукається за точним збігом code_value з числом.',
        'Діапазон — береться перший елемент списку, у якого range_min ≤ значення ≤ range_max; межі включні, порожня межа означає нескінченність. Якщо діапазони перекриваються, спрацює той, що вище в списку.',
      ],
      tagTitle: 'Тег групи',
      tag: 'Тег, значення якого розшифровується. У базі це список, але інтерфейс дозволяє один тег на групу. Теги створюються на вкладці «Теги».',
      codeValueTitle: 'Код (code_value)',
      codeValue: 'Точне число, з яким порівнюється значення тега. Збіг має бути повним — найближче значення не підбирається.',
      rangeTitle: 'Межі діапазону',
      range: 'Обидві межі включні. Порожній Range Min — мінус нескінченність, порожній Range Max — плюс нескінченність. Хоча б одну межу треба вказати: елемент без обох меж не спрацює ніколи.',
    },
  },
  en: {
    tabProjectLists: 'Project lists',
    tabItems: 'List items',
    listsTitle: 'Project lists',
    createList: 'Create list',
    colName: 'Name',
    colType: 'Type',
    colMode: 'Mode',
    colTarget: 'Target',
    actions: 'Actions',
    emptyLists: 'No lists',
    help: {
      groupsTitle: 'Code groups',
      groups: [
        'A code group decodes a numeric tag value into text. When a packet arrives the backend finds the matching item and writes its name into "<group>_decoded", plus "<group>_severity" if the item has a severity.',
        'If no item matches, "_decoded" is not filled at all — the card shows an empty slot rather than "unknown".',
      ],
      valueModeTitle: 'Decoding mode',
      valueMode: [
        'Tag value — the item is matched by exact equality of code_value with the number.',
        'Range — the first item in the list where range_min ≤ value ≤ range_max wins; bounds are inclusive and an empty bound means infinity. With overlapping ranges the one higher in the list wins.',
      ],
      tagTitle: 'Group tag',
      tag: 'The tag whose value gets decoded. The database stores a list, but the UI allows one tag per group. Tags are created on the Tags tab.',
      codeValueTitle: 'Code (code_value)',
      codeValue: 'The exact number the tag value is compared against. The match must be exact — the nearest value is not picked.',
      rangeTitle: 'Range bounds',
      range: 'Both bounds are inclusive. An empty Range Min means minus infinity, an empty Range Max means plus infinity. At least one bound is required: an item with neither will never match.',
    },
  },
};

const UID_MGMT_V2 = {
  uk: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    backToList: 'Назад до списку UID',
    manageTitle: 'Керування UID',
    project: 'Проєкт',
    svgRuntime: 'SVG Runtime',
    errSuperAdminId: 'Не вдалося визначити ID суперадміна',
    errUidNotAssigned: 'UID не знайдено або не призначено вам',
    errLoad: 'Помилка завантаження UID',
    uidNotFound: 'UID не знайдено',
    tabStations: 'Станції',
    tabTags: 'Теги',
    tabLists: 'Списки',
    tabCards: 'Картки',
    tabSvg: 'SVG',
    tabAlarms: 'Аварії',
    tabCommands: 'Команди',
    tabTrends: 'Тренди',
    tabTelegram: 'Telegram',
    tabBundle: 'Backup',
    bundle: {
      title: 'Backup / Restore UID',
      description:
        'Один CSV-файл містить всю конфігурацію UID (теги, станції, аварії, тренди, списки, команди, картки). SVG-конфіги в файл не входять — їх потрібно перенести вручну.',
      exportTitle: 'Експорт',
      exportHint: 'Завантажити повний бекап поточного UID.',
      exportButton: 'Експорт bundle CSV',
      importTitle: 'Імпорт',
      modeRestore: 'Restore — повна заміна конфігурації цього UID',
      modeClone: 'Clone — злити (upsert) у цей UID з файлу',
      applyUidMeta: 'Застосувати UID_META (ім\'я, ліміти)',
      applyTelegramSecrets: 'Перенести telegram-секрети UID (не рекомендовано)',
      confirmRestore: 'Я розумію: restore перезапише всю конфігурацію UID',
      confirmRestoreRequired: 'Підтвердіть restore перед імпортом',
      importButton: 'Імпорт bundle CSV',
      resultTitle: 'Результат імпорту',
      resultTotals: 'Створено / оновлено / пропущено',
      created: 'ств.',
      updated: 'онов.',
      errors: 'Помилки',
      errExport: 'Не вдалося експортувати bundle',
      errImport: 'Не вдалося імпортувати bundle',
      help: {
        title: 'Імпорт bundle',
        import: [
          'Restore спочатку видаляє теги, станції, аварії, тренди, групи кодів, команди і картки цього UID, потім завантажує файл і завжди записує name, station_type і max_stations. Clone оновлює теги за var, станції за номером, команди і групи кодів за назвою і не чіпає рядки, яких у файлі немає.',
          'Якщо в файлі є помилка, транзакція відкочується цілком: частково конфігурація не застосовується.',
        ],
        metaTitle: 'UID_META',
        meta: [
          'У режимі clone галочка записує з файлу name, station_type і max_stations. У restore ці поля застосовуються завжди, галочка не показується. Telegram-секрети з файлу ця форма не переносить.',
          'max_stations зараз зводиться до 0 або 1: будь-яке значення, крім 0 і false, зберігається як 1.',
        ],
      },
    },
  },
  en: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    backToList: 'Back to UID list',
    manageTitle: 'UID management',
    project: 'Project',
    svgRuntime: 'SVG Runtime',
    errSuperAdminId: 'Could not determine superadmin ID',
    errUidNotAssigned: 'UID not found or not assigned to you',
    errLoad: 'Failed to load UID',
    uidNotFound: 'UID not found',
    tabStations: 'Stations',
    tabTags: 'Tags',
    tabLists: 'Lists',
    tabCards: 'Cards',
    tabSvg: 'SVG',
    tabAlarms: 'Alarms',
    tabCommands: 'Commands',
    tabTrends: 'Trends',
    tabTelegram: 'Telegram',
    tabBundle: 'Backup',
    bundle: {
      title: 'Backup / Restore UID',
      description:
        'One CSV file holds the full UID configuration (tags, stations, alarms, trends, code groups, commands, cards). SVG configs are not included — recreate them manually.',
      exportTitle: 'Export',
      exportHint: 'Download a full backup of this UID.',
      exportButton: 'Export bundle CSV',
      importTitle: 'Import',
      modeRestore: 'Restore — full replace of this UID config',
      modeClone: 'Clone — merge (upsert) into this UID from file',
      applyUidMeta: 'Apply UID_META (name, limits)',
      applyTelegramSecrets: 'Transfer UID telegram secrets (not recommended)',
      confirmRestore: 'I understand: restore will overwrite all UID configuration',
      confirmRestoreRequired: 'Confirm restore before import',
      importButton: 'Import bundle CSV',
      resultTitle: 'Import result',
      resultTotals: 'Created / updated / skipped',
      created: 'created',
      updated: 'updated',
      errors: 'Errors',
      errExport: 'Failed to export bundle',
      errImport: 'Failed to import bundle',
      help: {
        title: 'Bundle import',
        import: [
          'Restore first deletes this UID’s tags, stations, alarms, trends, code groups, commands, and cards, then loads the file and always writes name, station_type, and max_stations. Clone updates tags by var, stations by number, and commands and code groups by name, and leaves rows that are not in the file.',
          'If the file has an error, the transaction rolls back entirely: the configuration is not applied in part.',
        ],
        metaTitle: 'UID_META',
        meta: [
          'In clone mode this box writes name, station_type, and max_stations from the file. In restore those fields are always applied and the box is hidden. This form does not transfer telegram secrets from the file.',
          'max_stations is currently collapsed to 0 or 1: any value other than 0 and false is stored as 1.',
        ],
      },
    },
  },
};
